import { render, staticRenderFns } from "./SwitchRole.vue?vue&type=template&id=653fd8d1&scoped=true&lang=html&"
import script from "./SwitchRole.vue?vue&type=script&lang=js&"
export * from "./SwitchRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653fd8d1",
  null
  
)

export default component.exports